<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-card no-body>
      <b-card-header>
        Download keuringsopmerkingen
      </b-card-header>
      <b-card-body>
        <b-form-row>
          <b-col>
            <b-form-group label="Relatie">
              <relatie-select 
                v-model="excel.relatie"
                @input="getTelling"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Installateur">
              <b-select
                v-model="excel.installateur"
                :options="installateurs"
                text-field="Naam"
                value-field="Id"
                @change="getTelling"
              >
                <template #first>
                  <option 
                    :value="null" 
                  >
                    -- Kies een onderhoudsfirma --
                  </option>
                </template>
              </b-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Periode">
              <b-input-group prepend="jaar">
                <b-input 
                  v-model.number="excel.jaar" 
                  type="number" 
                  @change="getTelling"
                />
                <b-input-group-text>
                  kwartaal
                </b-input-group-text>
                <b-input 
                  v-model.number="excel.kwartaal" 
                  type="number" 
                  min="1"
                  step="1"
                  max="4" 
                  @change="getTelling"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-card-body>
      <b-card-footer>
        <b-card-text class="pull-right">
          {{ telling }} opmerkingen
        </b-card-text><br><br>
        <b-button 
          :disabled="telling < 1" 
          size="lg"
          variant="success"
          class="pull-right" 
          @click="downloadExcel"
        >
          <b-spinner 
            v-if="busy"
            small
          /> <i 
            v-else 
            class="fa fa-table"
          /> Download Excel
        </b-button><br>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>
<script>
import { saveAs } from "file-saver";
import { serviceMixin } from "@/mixins/serviceMixin";
import RelatieSelect from '../RelatieSelect.vue';

export default {
    name: 'DownloadKeuringsOpmerkingen',
    components: { RelatieSelect },
    mixins: [serviceMixin,],
    props: {
    },
    data() {
        return  {
            telling: -1,
            excel : {
                jaar: new Date().getUTCFullYear(),
                kwartaal: Math.floor(new Date().getMonth() / 3 + 1),
                installateur: null,
                relatie: null
            },
            downloadnaam: 'keurings-opmerkingen.xlsx',
            busy: false,
            installateurs: [],
        }
    },
    computed: {
    criteria: function() {
        return {
          onderhoudsfirma: this.excel.installateur == null ? null : this.excel.installateur.toString(),
          relatie: this.excel.relatie == null ? null : this.excel.relatie.id.toString()
        }
        
      }
    },
    mounted () {
        this.getOnderhoudsfirmas();
    },
    methods: {
        getOnderhoudsfirmas() {
      var vm = this;
      this.get("/onderhoud/relaties")
        .then(function (response) {
          console.dir(response.data);
          vm.installateurs = response.data.relaties;
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      getTelling() {
        var vm = this;
        this.busy = true;
        this.post(`/keuringsopmerkingen/${this.excel.jaar}/${this.excel.kwartaal}/telling`, this.criteria)
          .then(function (response) {
            console.dir(response.data);
            vm.telling = response.data.aantal;
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function () {
          vm.busy = false;
        });
      },
      downloadExcel() {
      var vm = this;
      this.busy = true;
      this.$http
        .post(
          `/keuringsopmerkingen/${this.excel.jaar}/${this.excel.kwartaal}`,
          this.criteria,
          { responseType: "arraybuffer" }
        )
        .then((response) => {
          console.log(response.data);
          var blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, vm.downloadNaam);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(function () {
          vm.busy = false;
        });
      }
    },
          
}
</script>